export function getRandomContainerId() {
  return Math.random().toString(36).substr(2, 8);
}
var sizeProps = ['width', 'minWidth', 'maxWidth', 'height', 'minHeight', 'maxHeight'];
export function getSizeProps(props) {
  return sizeProps.reduce(function (previousValue, currentValue) {
    var value = props[currentValue];

    if (typeof value !== 'undefined') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      previousValue[currentValue] = value;
    }

    return previousValue;
  }, {});
}